module.exports = __webpack_public_path__ + "static/media/steelRollet.bbd41fa2.jpg";